module.exports = {
  GalleryData: () => {
    return {
      "avatr7" : 
        [
          {
            "id": "design-list_05.jpg",
            "name" : "",
            "desc" : "",
            "image": require("../assets/images/avatr7/design-list_05.jpg"),
            "active" : true
          },
          {
            "id": "design-ratio.jpg",
            "name" : "",
            "desc" : "",
            "image": require("../assets/images/avatr7/design-ratio.jpg"),
            "active" : true
          },
          {
            "id": "design-list_01.jpg",
            "name" : "",
            "desc" : "",
            "image": require("../assets/images/avatr7/design-list_01.jpg"),
            "active" : true
          },
          {
            "id": "design-list_02.jpg",
            "name" : "",
            "desc" : "",
            "image": require("../assets/images/avatr7/design-list_02.jpg"),
            "active" : true
          },
          // {
          //   "id": "Full_Caramel_Luxe.jpg",
          //   "name" : "",
          //   "desc" : "",
          //   "image": require("../assets/images/avatr7/Full_Caramel_Luxe.jpg"),
          //   "active" : true
          // },
          // {
          //   "id": "interior-space.jpg",
          //   "name" : "",
          //   "desc" : "",
          //   "image": require("../assets/images/avatr7/interior-space.jpg"),
          //   "active" : true
          // },

          // {
          //   "id": "Blue.jpg",
          //   "name" : "",
          //   "desc" : "",
          //   "image": require("../assets/images/avatr7/Blue.png"),
          //   "active" : true
          // },
          // {
          //   "id": "Black.jpg",
          //   "name" : "",
          //   "desc" : "",
          //   "image": require("../assets/images/avatr7/Black.png"),
          //   "active" : true
          // },
          // {
          //   "id": "Gray.jpg",
          //   "name" : "",
          //   "desc" : "",
          //   "image": require("../assets/images/avatr7/Gray.png"),
          //   "active" : true
          // },
          // {
          //   "id": "Purple.jpg",
          //   "name" : "",
          //   "desc" : "",
          //   "image": require("../assets/images/avatr7/Purple.png"),
          //   "active" : true
          // },
          
        ],
      "avatr11" :
        [
          {
            "id": "design-content_01.jpg",
            "name" : "",
            "desc" : "",
            "image": require("../assets/images/avatr11/design-content_01.jpg"),
            "active" : true
          },
          {
            "id": "design-content_02.jpg",
            "name" : "",
            "desc" : "",
            "image": require("../assets/images/avatr11/design-content_02.jpg"),
            "active" : true
          },
          {
            "id": "design-content_03.jpg",
            "name" : "",
            "desc" : "",
            "image": require("../assets/images/avatr11/design-content_03.jpg"),
            "active" : true
          },
          {
            "id": "design-content_04.jpg",
            "name" : "",
            "desc" : "",
            "image": require("../assets/images/avatr11/design-content_04.jpg"),
            "active" : true
          },
          {
            "id": "design-content_05.jpg",
            "name" : "",
            "desc" : "",
            "image": require("../assets/images/avatr11/design-content_05.jpg"),
            "active" : true
          },
          // {
          //   "id": "Full_Caramel_Luxe.jpg",
          //   "name" : "",
          //   "desc" : "",
          //   "image": require("../assets/images/avatr7/Full_Caramel_Luxe.jpg"),
          //   "active" : true
          // },
          // {
          //   "id": "interior-space.jpg",
          //   "name" : "",
          //   "desc" : "",
          //   "image": require("../assets/images/avatr7/interior-space.jpg"),
          //   "active" : true
          // },

          // {
          //   "id": "Blue.jpg",
          //   "name" : "",
          //   "desc" : "",
          //   "image": require("../assets/images/avatr7/Blue.png"),
          //   "active" : true
          // },
          // {
          //   "id": "Black.jpg",
          //   "name" : "",
          //   "desc" : "",
          //   "image": require("../assets/images/avatr7/Black.png"),
          //   "active" : true
          // },
          // {
          //   "id": "Gray.jpg",
          //   "name" : "",
          //   "desc" : "",
          //   "image": require("../assets/images/avatr7/Gray.png"),
          //   "active" : true
          // },
          // {
          //   "id": "Purple.jpg",
          //   "name" : "",
          //   "desc" : "",
          //   "image": require("../assets/images/avatr7/Purple.png"),
          //   "active" : true
          // },
          
        ],
    }
  }
}